import { HttpClient } from '@euler/lib/request';
import {
  ApdmApproveReplyDraftInput,
  ApdmEditReplyDraftInput,
  ApdmReplyDraftReviewActionResult,
  ApdmReplyDraftReviewDetailInput,
  ApdmReplyDraftReviewDetailResult,
  ApdmReplyDraftReviewListInput,
  ApdmReplyDraftReviewListResult,
} from '@euler/model/apdm';

export class ApdmReviewService {
  constructor(private readonly api: HttpClient) {}
  async list(
    input: ApdmReplyDraftReviewListInput,
  ): Promise<ApdmReplyDraftReviewListResult> {
    return await this.api
      .get()
      .url('/apdm/campaign-drafts', {
        scope: input.scope ?? undefined,
        campaignId: input.campaignId ?? undefined,
        afterDraftId: input.afterDraftId ?? undefined,
        status: input.status ?? undefined,
        limit: input.limit,
      })
      .future();
  }
  async detail(
    input: ApdmReplyDraftReviewDetailInput,
  ): Promise<ApdmReplyDraftReviewDetailResult> {
    return await this.api
      .get()
      .url('/apdm/campaign-drafts/:draftId', { draftId: input.draftId })
      .future();
  }
  async send(
    input: ApdmApproveReplyDraftInput,
  ): Promise<ApdmReplyDraftReviewActionResult> {
    return await this.action('send', input);
  }
  async editSend(
    input: ApdmEditReplyDraftInput,
  ): Promise<ApdmReplyDraftReviewActionResult> {
    return await this.action('send', input);
  }
  async discard(
    input: ApdmApproveReplyDraftInput,
  ): Promise<ApdmReplyDraftReviewActionResult> {
    return await this.action('discard', input);
  }
  private async action(
    action: 'send' | 'discard',
    input: ApdmApproveReplyDraftInput | ApdmEditReplyDraftInput,
  ): Promise<ApdmReplyDraftReviewActionResult> {
    return await this.api
      .post()
      .url('/apdm/campaign-drafts/:draftId/' + action, {
        draftId: input.ref.draftId,
      })
      .data({
        ref: {
          campaignId: input.ref.campaignId,
          expectedVersion: input.ref.expectedVersion,
        },
        expectedFingerprint: input.expectedFingerprint,
        ...('text' in input ? { text: input.text } : {}),
      })
      .future();
  }
}
